// extracted by mini-css-extract-plugin
export var integrationButton = "_am-0";